import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgRatingsComponent } from "./ng-ratings.component";
import { NgPopupModule } from "../ng-popup/ng-popup.module";
import { NgRatingsService } from "./ng-ratings.service";
import { Http } from "@angular/http";

function NgRatingsServiceFactory(http: Http): NgRatingsService {
    return NgRatingsService.getInstance(http);
}

@NgModule({
    imports: [
        CommonModule,
        NgPopupModule
    ],
    declarations: [
        NgRatingsComponent
    ],
    providers: [
        {
            provide: NgRatingsService,
            useFactory:  NgRatingsServiceFactory,
            deps: [
                Http
            ]
        }
    ],
    exports: [
        NgRatingsComponent
    ]
})
export class NgRatingsModule {
}

